// Table filters moved to localStorage (`@shared/lib/tableFilters`); what
// is left in sessionStorage is per-tab state that a sign-out drops.
export const clearSessionData = () => sessionStorage.clear();
